import React from 'react';
import NavigationBar from '../navbar/NavigationBar';
import Footer from '../navbar/Footer';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import WarningIcon from '@mui/icons-material/Warning';
import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';
import SchoolIcon from '@mui/icons-material/School';
import GroupsIcon from '@mui/icons-material/Groups';

const TrainingLaunchPageB = () => {
  // Image de couverture (photo principale de Mugere)
  const imageUrl = '/assets/rppcub/RPPCUB_MUGERE_DG.jpg';

  // --- PHOTOS DE MUGERE (remplacez par vos vraies photos) ---
  const imagesMugere = [
    {
      src: '/assets/rppcub/RPPCUB_MUGERE_AR.jpg',
      alt: 'Ouverture de la formation à Mugere - Tiger\'s Appartement',
      caption: 'Tiger\'s Appartement – Accueil des candidats présélectionnés'
    },
    {
      src: '/assets/rppcub/RPPCUB_MUGERE_DG.jpg',
      alt: 'Visite du DG à Mugere',
      caption: 'Le Directeur Général de l\'INSBU s\'adresse aux candidats'
    },
    {
      src: '/assets/rppcub/RPPCUB_MUGERE_DG_AR.jpg',
      alt: 'Participants à la formation de Mugere',
      caption: 'Les candidats présélectionnés suivent attentivement les instructions'
    }
  ];

  return (
    <div style={styles.container}>
      <NavigationBar />
      
      <main style={styles.main}>
        <header style={styles.header}>
          <div style={styles.badges}>
            <span style={styles.badgeRed}>INSBU</span>
            <span style={styles.badgeGreen}>RPPCUB</span>
            <span style={styles.badgeGray}>Actualité</span>
          </div>

          <h1 style={styles.title}>
            RPPCUB 2026 : Le Directeur Général de l’INSBU en visite à Mugere pour encourager les agents recenseurs
          </h1>

          <div style={styles.meta}>
            <span style={styles.metaItem}>
              <CalendarTodayIcon style={styles.metaIcon} /> Publié le 5 août 2026
            </span>
            <span style={styles.metaItem}>
              <LocationOnIcon style={styles.metaIcon} /> Mugere, Burundi
            </span>
            <span style={styles.metaItem}>
              <AccessTimeIcon style={styles.metaIcon} /> Lecture 3 min
            </span>
          </div>

          {/* PHOTO DE COUVERTURE */}
          <div style={styles.imageWrapper}>
            <img 
              src={imageUrl} 
              alt="Lancement de la formation RPPCUB 2026 à Mugere - Tiger's Appartement" 
              style={styles.heroImage}
            />
            <p style={styles.imageCaption}>
              Les candidats présélectionnés à Mugere suivent avec attention les instructions du Directeur Général de l'INSBU
            </p>
          </div>

          <p style={styles.chapeau}>
            Ce lundi 3 août 2026, la commune de <strong>Mugere</strong> a officiellement lancé les formations du RPPCUB 2026 à <strong>Tiger's Appartement</strong>. Les candidats présélectionnés ont été honorés par la visite du <strong>Directeur Général de l’INSBU, M. Nicolas NDAYISHIMIYE</strong>, venu les encourager et leur prodiguer de précieux conseils pour la réussite de cette opération d’envergure nationale.
          </p>
        </header>

        <article style={styles.article}>
          
          {/* SECTION 1 : Mugere en action */}
          <h2 style={styles.h2}>
            <SchoolIcon style={{ fontSize: '1.8rem', marginRight: '10px', verticalAlign: 'middle', color: '#008D36' }} />
            1. Mugere, une commune déterminée à réussir le RPPCUB
          </h2>
          <p style={styles.p}>
            Ce lundi 3 août 2026, à 08h00 précises, la salle de formation de <strong>Tiger's Appartement (Mugere)</strong> a ouvert ses portes aux candidats présélectionnés pour la phase 2 du Recensement des Propriétaires des Propriétés/Parcelles dans les centres urbains du Burundi. L’assiduité était au rendez-vous, témoignant de l’engagement de ces futurs agents recenseurs.
          </p>
          <p style={styles.p}>
            Le conseiller communal en charge de la communication communale de Mugere a procédé à l’ouverture officielle des travaux en saluant l’enthousiasme des participants et en rappelant l’importance stratégique de cette opération. Dans son allocution, il a insisté sur la nécessité de <strong>« collecter des données fiables qui serviront de socle à la politique foncière nationale »</strong>.
          </p>

          {/* Galerie Mugere */}
          <h3 style={styles.galleryTitle}>
            <PhotoCameraIcon style={{ fontSize: '1.5rem', marginRight: '8px', verticalAlign: 'middle', color: '#008D36' }} />
            En images : la formation à Mugere
          </h3>
          <div style={styles.galleryGrid}>
            {imagesMugere.map((item, index) => (
              <div key={index} style={styles.galleryItem}>
                <img 
                  src={item.src} 
                  alt={item.alt} 
                  style={styles.galleryImg}
                  onError={(e) => { e.target.src = 'https://placehold.co/300x200/008D36/FFFFFF?text=Mugere'; }}
                />
                <p style={styles.galleryCaption}>{item.caption}</p>
              </div>
            ))}
          </div>

          {/* SECTION 2 : Visite du DG */}
          <h2 style={styles.h2}>
            <GroupsIcon style={{ fontSize: '1.8rem', marginRight: '10px', verticalAlign: 'middle', color: '#008D36' }} />
            2. Le Directeur Général de l’INSBU à Mugere : un encouragement de taille
          </h2>
          <p style={styles.p}>
            La journée inaugurale à Mugere a été marquée par une visite de haut niveau. Le <strong>Directeur Général de l’INSBU, M. Nicolas NDAYISHIMIYE</strong>, a effectué un déplacement à Tiger's Appartement pour rencontrer les candidats présélectionnés. Cette présence a électrisé la salle et démontré l’importance capitale accordée par la plus haute autorité de l’INSBU à ce recensement.
          </p>
          <div style={styles.dgBox}>
            <p style={styles.dgMessage}>
              « Je tiens à vous féliciter pour votre assiduité et votre engagement. Vous êtes les maillons essentiels de cette opération d’envergure nationale. La qualité des données que vous collecterez dépendra de votre rigueur, de votre honnêteté et de votre sens de l’écoute. »
            </p>
            <p style={styles.dgMessage}>
              Le DG a ensuite prodigué de précieux conseils : <strong>« N’hésitez jamais à poser des questions aux formateurs. Maîtrisez parfaitement les outils numériques qui vous sont confiés. Sur le terrain, soyez patients, courtois mais fermes. Vous représentez l’État et la crédibilité de nos statistiques. »</strong>
            </p>
            <p style={{ ...styles.dgMessage, borderTop: '1px solid #b0d4e0', paddingTop: '12px' }}>
              Le Directeur Général a également insisté sur un point fondamental : la <strong>conservation et la sécurisation des outils</strong> de collecte. 
              <em>« Les tablettes et tout autre matériel qui vous seront confiés sont des biens publics. Vous devez en prendre soin et les sécuriser à tout moment. Toute perte, détérioration ou usage inapproprié pourrait compromettre le déroulement du recensement. Votre responsabilité est engagée, et des sanctions sont prévues en cas de négligence. »</em>
            </p>
          </div>
          <p style={styles.p}>
            Les agents recenseurs ont vivement apprécié cette marque de considération. Cette visite a renforcé leur motivation et leur détermination à mener à bien cette mission cruciale pour la modernisation foncière du Burundi.
          </p>

          {/* SECTION 3 : Calendrier complet (rappel des dates) */}
          <h2 style={styles.h2}>
            <CalendarTodayIcon style={{ fontSize: '1.8rem', marginRight: '10px', verticalAlign: 'middle', color: '#008D36' }} />
            3. Le calendrier complet des formations
          </h2>
          <p style={styles.p}>
            Pour rappel, voici la répartition géographique validée par l’INSBU pour l’ensemble des agents recenseurs et chefs d’équipes :
          </p>
          <div style={styles.infoBlock}>
            <p style={styles.p}>
              <strong>Phase 1 (28 au 31 juillet) :</strong> Ngozi (HOPA), Rumonge (Galaxy Hotel), Gitega (Sunset Hotel).
            </p>
            <p style={styles.p}>
              <strong>Phase 2 (3 au 6/7 août) :</strong> Ntahangwa (Espace Isaganirizo), Mugere (Tiger's Appartement), Mukaza (CEPRODILIC).
            </p>
            <p style={styles.p}>
              <strong>Chefs d’équipes :</strong> Des sessions spécifiques sont prévues les 1er, 7 et 8 août (déjà réalisées pour la phase 1) et se poursuivent pour encadrer la collecte.
            </p>
          </div>

          <div style={styles.lieuxBox}>
            <p style={styles.lieuxTitle}>
              <LocationOnIcon style={styles.lieuxIcon} /> Détail des lieux de formation (toutes phases)
            </p>
            <ul style={styles.lieuxList}>
              <li style={styles.lieuxItem}><strong>Ngozi</strong> – Hôtel Ombre des Patriotes (HOPA)</li>
              <li style={styles.lieuxItem}><strong>Rumonge</strong> – Galaxy Hotel</li>
              <li style={styles.lieuxItem}><strong>Gitega</strong> – Sunset Hotel</li>
              <li style={styles.lieuxItem}>
                <strong>Ntahangwa</strong> – Espace Isaganirizo (ESIS) – à 300 m du bureau communal, direction Gihanga.
              </li>
              <li style={styles.lieuxItem}><strong>Mugere</strong> – Tiger's Appartement</li>
              <li style={styles.lieuxItem}><strong>Mukaza</strong> – CEPRODILIC</li>
            </ul>
          </div>

          {/* SECTION 4 : Intégrité */}
          <h2 style={styles.h2}>
            <WarningIcon style={{ fontSize: '1.8rem', marginRight: '10px', verticalAlign: 'middle', color: '#E30613' }} />
            4. Intégrité et ponctualité : les piliers de la mission
          </h2>
          <p style={styles.p}>
            L’Administrateur de Mugere et le Directeur Général ont martelé les mêmes règles d’or :
          </p>
          <ul style={styles.ul}>
            <li style={styles.li}>
              <strong>Tolérance zéro contre la corruption :</strong> <em>« Aucun cadeau ni faveur. Toute dérive sera sanctionnée. »</em>
            </li>
            <li style={styles.li}>
              <strong>La ponctualité :</strong> Les sessions débutent impérativement à 08h00. Un retard équivaut à un désistement.
            </li>
            <li style={styles.li}>
              <strong>Sécurisation des outils :</strong> Tablettes, batteries et fiches de collecte doivent être protégés et utilisés avec rigueur.
            </li>
          </ul>
          <div style={styles.attentionBox}>
            <WarningIcon style={styles.attentionIcon} />
            <p style={styles.attentionText}>
              Le DG de l’INSBU a ajouté une recommandation forte : <strong>« En cas de difficulté sur le terrain, ne restez jamais isolés. Remontez l’information à votre chef d’équipe ou aux autorités locales. L’administration est votre rempart. »</strong>
            </p>
          </div>

          {/* CONCLUSION */}
          <div style={styles.conclusion}>
            <p style={styles.p}>
              Avec la visite du Directeur Général à Mugere, le RPPCUB 2026 entre dans une phase décisive. Les agents recenseurs de Mugere, désormais en formation, se préparent à arpenter les quartiers pour une collecte de données exemplaire.
            </p>
            <p style={styles.p}>
              Les formations se poursuivent cette semaine. Le grand déploiement sur le terrain est imminent. Le Burundi s’apprête à franchir une nouvelle étape dans la modernisation de sa gestion foncière.
            </p>
            <p style={styles.vive}>
              <strong>Vive le RPPCUB, vive le Burundi !</strong>
            </p>
          </div>

        

        </article>
      </main>

      <Footer />
    </div>
  );
};

// ================= STYLES =================
const styles = {
  container: {
    backgroundColor: '#f5f5f5',
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
  },
  main: {
    flex: 1,
    maxWidth: '820px',
    margin: '0 auto',
    padding: '40px 20px',
    width: '100%',
  },
  header: {
    textAlign: 'center',
    marginBottom: '40px',
    paddingBottom: '30px',
    borderBottom: '2px solid #e0e0e0',
  },
  badges: {
    display: 'flex',
    justifyContent: 'center',
    gap: '10px',
    marginBottom: '20px',
    flexWrap: 'wrap',
  },
  badgeRed: {
    backgroundColor: '#E30613',
    color: 'white',
    padding: '4px 14px',
    borderRadius: '20px',
    fontSize: '0.75rem',
    fontWeight: '600',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
  badgeGreen: {
    backgroundColor: '#008D36',
    color: 'white',
    padding: '4px 14px',
    borderRadius: '20px',
    fontSize: '0.75rem',
    fontWeight: '600',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
  badgeGray: {
    backgroundColor: '#6c757d',
    color: 'white',
    padding: '4px 14px',
    borderRadius: '20px',
    fontSize: '0.75rem',
    fontWeight: '600',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
  title: {
    color: '#1a1a1a',
    fontSize: '2.4rem',
    fontWeight: '700',
    lineHeight: 1.2,
    marginBottom: '12px',
    letterSpacing: '-0.3px',
  },
  meta: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    gap: '20px',
    marginBottom: '20px',
    fontSize: '0.9rem',
    color: '#6c757d',
  },
  metaItem: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '5px',
  },
  metaIcon: {
    fontSize: '1rem',
    color: '#008D36',
  },
  imageWrapper: {
    marginBottom: '24px',
    borderRadius: '8px',
    overflow: 'hidden',
  },
  heroImage: {
    width: '100%',
    height: 'auto',
    maxHeight: '420px',
    objectFit: 'cover',
    display: 'block',
    borderRadius: '8px 8px 0 0',
  },
  imageCaption: {
    fontSize: '0.85rem',
    color: '#6c757d',
    textAlign: 'center',
    padding: '8px 0 4px 0',
    fontStyle: 'italic',
    backgroundColor: '#fafafa',
    margin: 0,
    borderBottom: '1px solid #eaeaea',
    borderRadius: '0 0 8px 8px',
  },
  chapeau: {
    fontSize: '1.2rem',
    lineHeight: 1.7,
    color: '#2c3e50',
    maxWidth: '700px',
    margin: '0 auto',
    fontWeight: '400',
    borderLeft: '4px solid #008D36',
    paddingLeft: '20px',
    textAlign: 'left',
  },
  article: {
    backgroundColor: 'white',
    padding: '40px 45px',
    borderRadius: '12px',
    boxShadow: '0 4px 20px rgba(0,0,0,0.04)',
    marginBottom: '40px',
  },
  h2: {
    color: '#008D36',
    fontSize: '1.5rem',
    fontWeight: '600',
    marginTop: '40px',
    marginBottom: '16px',
    paddingBottom: '6px',
    borderBottom: '2px solid #eaeaea',
    display: 'flex',
    alignItems: 'center',
  },
  p: {
    fontSize: '1.05rem',
    lineHeight: 1.8,
    color: '#1e1e1e',
    marginBottom: '20px',
    textAlign: 'justify',
  },
  ul: {
    paddingLeft: '20px',
    marginBottom: '20px',
  },
  li: {
    fontSize: '1.05rem',
    lineHeight: 1.8,
    color: '#1e1e1e',
    marginBottom: '10px',
  },
  infoBlock: {
    backgroundColor: '#f8fafc',
    padding: '20px 25px',
    borderRadius: '8px',
    borderLeft: '4px solid #008D36',
    marginBottom: '25px',
  },
  lieuxBox: {
    backgroundColor: '#f0f7f4',
    padding: '20px 25px',
    borderRadius: '8px',
    border: '1px solid #d0e6dc',
    marginBottom: '30px',
  },
  lieuxTitle: {
    fontWeight: '700',
    fontSize: '1.05rem',
    color: '#008D36',
    marginBottom: '8px',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  lieuxIcon: {
    fontSize: '1.3rem',
    color: '#008D36',
  },
  lieuxList: {
    listStyle: 'none',
    padding: 0,
    margin: '8px 0 0 0',
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))',
    gap: '6px 20px',
  },
  lieuxItem: {
    fontSize: '0.95rem',
    lineHeight: 1.6,
    color: '#1e1e1e',
  },
  attentionBox: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '12px',
    backgroundColor: '#fef3f2',
    padding: '18px 22px',
    borderRadius: '8px',
    border: '1px solid #f5c6cb',
    marginBottom: '30px',
  },
  attentionIcon: {
    fontSize: '1.6rem',
    color: '#E30613',
    flexShrink: 0,
    marginTop: '2px',
  },
  attentionText: {
    margin: 0,
    fontSize: '1rem',
    lineHeight: 1.7,
    color: '#721c24',
  },
  conclusion: {
    marginTop: '30px',
    paddingTop: '20px',
    borderTop: '1px solid #eaeaea',
  },
  vive: {
    fontSize: '1.3rem',
    fontWeight: '700',
    color: '#008D36',
    textAlign: 'center',
    marginTop: '20px',
    letterSpacing: '0.5px',
  },
  signature: {
    textAlign: 'center',
    marginTop: '40px',
    paddingTop: '20px',
    borderTop: '1px solid #eaeaea',
    color: '#6c757d',
    fontSize: '0.9rem',
    letterSpacing: '0.3px',
  },

  // GALERIES
  galleryTitle: {
    fontSize: '1.2rem',
    fontWeight: 600,
    color: '#008D36',
    marginTop: '10px',
    marginBottom: '16px',
    textAlign: 'center',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  galleryGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: '16px',
    marginBottom: '25px',
  },
  galleryItem: {
    backgroundColor: '#fff',
    borderRadius: '8px',
    overflow: 'hidden',
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
    border: '1px solid #eaeaea',
  },
  galleryImg: {
    width: '100%',
    height: '170px',
    objectFit: 'cover',
    display: 'block',
  },
  galleryCaption: {
    padding: '8px 10px',
    fontSize: '0.75rem',
    textAlign: 'center',
    color: '#2c3e50',
    fontWeight: 600,
    backgroundColor: '#fafafa',
    margin: 0,
    borderTop: '1px solid #eaeaea',
  },

  // DG BOX
  dgBox: {
    backgroundColor: '#e8f4f8',
    padding: '20px 25px',
    borderRadius: '8px',
    borderLeft: '4px solid #008D36',
    marginBottom: '25px',
  },
  dgMessage: {
    fontSize: '1.05rem',
    lineHeight: 1.8,
    color: '#0d3b4a',
    marginBottom: '12px',
    fontStyle: 'italic',
    '&:last-child': {
      marginBottom: 0,
    },
  },
};

export default TrainingLaunchPageB;